module.exports = __webpack_public_path__ + "img/home-bg2.e308fb0e.jpg";